import React, { Component } from "react";
import { encryptData } from "./utils/encryptionUtils";
import { getClientId } from "./utils/analyticsclientIdUtils";
import ZPartner02Header from "./ZPartner02Header";
import ZPartner02Footer from "./ZPartner02Footer";

export class ZPartner02MemberSignin extends Component {
    static displayName = ZPartner02MemberSignin.name;

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            loginstatus: "",
            requireMsgEmail: "",
            requireMsgPwd: "",
            showPassword: false,
            submitting: false,
            refUserId: "",
            switchBackUrl: "",
            jcheck: ""
        };
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "Partner02_MemberSignin_Step01";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });        

        // #region "back button / history handling"
        if (typeof window !== "undefined" && window.history && window.history.pushState) {
            window.history.pushState(null, "", window.location.href);

            this.handlePopState = (event) => {
                window.history.pushState(null, "", window.location.href);
            };

            window.addEventListener("popstate", this.handlePopState);
        }
        // #endregion

        // Read parameters
        const { refUserId, switchBackUrl } = this.props.location.state || {};

        // If any required parameter is missing, redirect to error page
        if (!refUserId || !switchBackUrl) {
            window.location.replace("/x02lineman/Error?S=param");
        }

        // Save values into state
        this.setState({ refUserId, switchBackUrl, jcheck: "done" });
    }

    componentWillUnmount() {
        // clear listener when exit component (prevent memory leak)
        if (this.handlePopState) {
            window.removeEventListener("popstate", this.handlePopState);
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleTogglePassword = () => {
        this.setState((prev) => ({ showPassword: !prev.showPassword }));
    };

    // Email validation
    validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        const { email, password, refUserId, switchBackUrl } = this.state;

        let canSubmit = true;

        // Reset messages
        this.setState({
            requireMsgEmail: "",
            requireMsgPwd: "",
            loginstatus: ""
        });

        // Validate email
        if (!email) {
            this.setState({ requireMsgEmail: "Enter an email" });
            canSubmit = false;
        } else if (!this.validateEmail(email)) {
            this.setState({ requireMsgEmail: "Please enter valid Email" });
            canSubmit = false;
        }

        // Validate password
        if (!password) {
            this.setState({ requireMsgPwd: "Enter a password" });
            canSubmit = false;
        }

        if (!canSubmit) {
            return;
        }

        // Prevent double submit
        this.setState({ submitting: true });
        document.body.classList.add("wait-cursor");

        const timestamp = Math.floor(Date.now() / 1000);

        // Payload for Line Signin
        const payload = {
            Email: email,
            Password: password,
            refUserId: refUserId,
            switchBackUrl: switchBackUrl,
            partnerCode: "002",
            Timestamp: timestamp
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/ZPartnerLinkBySignIn`, requestOptions);
            const data = await response.json();

            if (data.responseCode === "00") {
                const message = (data.responseMessage || "").toLowerCase();
                document.body.classList.remove("wait-cursor");

                // Redirect after successful signin
                const encodedUrl = encodeURIComponent(switchBackUrl);
                switch (message) {
                    case "success":
                        window.location.replace(`/x02lineman/MemberSigninSuccess/?S=${encodedUrl}`);
                        break;
                    case "error-sralreadylink":
                        window.location.replace("/x02lineman/Error?S=sralreadylink");
                        break;
                    case "error-faildblink":
                        window.location.replace("/x02lineman/Error?S=faildblink");
                        break;
                    case "error-failgrabnoti":
                        window.location.replace("/x02lineman/Error?S=failgrabnoti");
                        break;
                    default:
                        window.location.replace(`/x02lineman/MemberSigninSuccess/?S=${encodedUrl}`);
                        break;
                }
            } else {
                const message = data.responseMessage || "Login failed";

                let t01 = message + "[ " + message
                    .replace("Invalid Email or Password ", "อีเมลหรือรหัสผ่านไม่ถูกต้อง สามารถใส่ได้อีกไม่เกิน ")
                    .replace(" more attempts your account will be locked for ", " ครั้ง หากยังไม่ถูกต้องบัญชีของคุณจะถูกล็อกเป็นเวลา ")
                    .replace(" hours", " ชั่วโมง")
                    .replace("Invalid username or password", "อีเมลหรือรหัสผ่านไม่ถูกต้อง")
                    .replace(
                        "Your account had been locked because you have reached the maximum number of invalid login attempts.",
                        "อีเมลหรือรหัสผ่านไม่ถูกต้อง บัญชีของคุณจะถูกล็อกเป็นเวลา 1 ชั่วโมง"
                    ) + " ]";

                this.setState({
                    loginstatus: t01,
                    submitting: false
                });

                document.body.classList.remove("wait-cursor");
            }
        } catch (error) {
            console.error("Error during LineSignin API:", error);
            this.setState({
                loginstatus: "Unexpected error occurred",
                submitting: false
            });

            document.body.classList.remove("wait-cursor");
        }
    };

    render() {
        const { refUserId, switchBackUrl, jcheck, email, password, submitting, loginstatus, requireMsgEmail, requireMsgPwd, showPassword } = this.state || {};

        if (jcheck !== "done") {
            return (
                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                    <h3 className="text-black">LOADING ...</h3>
                    <img src="media/loading-gif.gif" alt="Loading..." width={80} className="img-fluid" />
                </div>
            );
        }

        return (
            <>
                <ZPartner02Header />

                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span>
                                        <img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row">
                                <div className="col-md-12 mb-5 pt-3 text-center">
                                    <h2 className="h3 mt-5 fw-bold text-dark-212121">เข้าสู่ระบบ<br />
                                        Sign in</h2>
                                </div>
                            </div>
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <form className="form-sr px-1 px-md-4" onSubmit={this.handleSubmit}>
                                            <p><span className="text-alert">* ข้อมูลที่จำเป็น / indicates required field</span></p>
                                            <div className="mb-4">
                                                <label htmlFor="exampleInputEmail1" className="form-label d-none">อีเมล / Email</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="อีเมล / Email"
                                                    name="email"
                                                    value={email}
                                                    onChange={this.handleChange}
                                                />
                                                <span className="text-danger">{requireMsgEmail}</span>
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="exampleInputPassword1" className="form-label d-none">Password</label>
                                                <div className="input-group mb-3">
                                                    <div className="input-group mb-3">
                                                        <input
                                                            type={showPassword ? "text" : "password"}
                                                            className="form-control border-end-0"
                                                            placeholder="รหัสผ่าน / Password"
                                                            name="password"
                                                            value={password}
                                                            onChange={this.handleChange}
                                                            id="password-field"
                                                        />
                                                        <span
                                                            className="input-group-text"
                                                            onClick={this.handleTogglePassword}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <i
                                                                className={
                                                                    "fa fa-fw toggle-password " +
                                                                    (showPassword ? "fa-eye" : "fa-eye-slash")
                                                                }
                                                            />
                                                        </span>
                                                    </div>
                                                    <span className="text-danger">{requireMsgPwd}</span>
                                                </div>
                                            </div>
                                            <p>ลืม <a href="https://rewards.starbucks.co.th/thforgotpwd">รหัสผ่าน?</a> / Forgot your <a href="https://rewards.starbucks.co.th/forgotpwd">password?</a></p>
                                            <div className="text-center">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary rounded-pill px-4 w-100"
                                                    disabled={submitting}
                                                >
                                                    <span className="text-sm Sarabun_fontthai text-bold">
                                                        {submitting ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ"}
                                                    </span>
                                                    <br />
                                                    <span className="text-xxs text-bold">
                                                        {submitting ? "Signing in..." : "Sign in"}
                                                    </span>
                                                </button>
                                            </div>
                                            <div className="text-center">
                                                <div className="req text-danger">
                                                    {loginstatus}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div style={{ marginTop: 24 }}>*/}
                        {/*    <small>*/}
                        {/*        Debug: Ref01 = {refUserId || "(empty)"} <br />*/}
                        {/*        ref02 = {switchBackUrl || "(empty)"}*/}
                        {/*    </small>*/}
                        {/*</div>*/}
                    </section>
                </main>                

                <ZPartner02Footer />
            </>
        );
    }
}
